module.exports = __webpack_public_path__ + "Server-Unhealthy.AzureServiceFabricCluster.74e2a9217718f8a42ad3cb4f8d74e3da.hashedasset.svg";